import Vue from 'vue';

Vue.component('subsidy-reimbursement-index', () =>
    import(/* webpackChunkName: 'subsidy-reimbursement-index' */ './subsidy-reimbursement-index.vue'),
);
